// extracted by mini-css-extract-plugin
module.exports = {"UsagePanel":"UsagePanel_UsagePanel__2o1mi"};